import { ReactiveFormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from "@angular/material/select";
import { MatDividerModule } from "@angular/material/divider";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TypesPopupComponent } from "./types-popup.component";
import { TRANSLOCO_SCOPE, TranslocoModule } from "@ngneat/transloco";

@NgModule({
  declarations: [TypesPopupComponent],
  imports: [
    MatDividerModule,
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    FlexLayoutModule,
    TranslocoModule,
  ],
  exports: [TypesPopupComponent],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: { scope: "finance", alias: "finance" },
    },
  ],
})
export class TypesPopupModule {}
